"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require("../node_modules/react/jsx-runtime.js");const e=require("./jsx-runtime2.js"),s=e.jsxRuntime.exports.jsx;exports.jsx=s;
